<b-modal v-model="modal_requirement_160" size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <!-- ヘッダー -->
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <!-- 文言表示 -->
  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid dialog-body">
        <div class="w-100">
          <div class="box-margin-right work-support-message">
            {{ workSupportMessage }}
          </div>
        </div>
      </div>
    </b-overlay>
  </template>

  <!-- フッター -->
  <template v-slot:footer>
    <div class="w-100 text-center ">
      <b-button v-if="showButtonOk" size="sm" :disabled="isLoading" variant="primary" @click="onOkClicked" class="mx-2">
        {{ $t('message.common_button_ok') }}
      </b-button>
      <b-button v-if="showButtonCancel" size="sm" :disabled="isLoading" variant="outline-primary"
        @click="onCancelClicked" class="mx-2">
        {{ $t('message.common_button_cancel') }}
      </b-button>
    </div>
  </template>
</b-modal>